import React, { useState } from 'react';
import {
  IRoleWithPermissionsFieldsFragment,
  IUserGroupFieldsFragment,
  IUserPermissionFieldsFragment,
  UserState,
} from '../../utils/apollo/graphqlSchema';
import ConfirmationModal from '../../components/ConfirmationModal';
import { closeModal } from '../../redux/slices/modal';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { usePermissionToggleMutation } from './hooks';
import { selectModalData } from '../../redux/selectors/modal';

interface IProps {
  refetch: () => void;
}
const PermissionToggleModal = ({ refetch }: IProps) => {
  const [loading, setLoading] = useState(false);
  const entity = useAppSelector(selectModalData) as
    | IUserPermissionFieldsFragment
    | IRoleWithPermissionsFieldsFragment
    | IUserGroupFieldsFragment;

  const isActive =
    'state' in entity ? entity.state === UserState.Active : entity.active;

  const { mutation, textDictionary } = usePermissionToggleMutation({
    entity,
    buttonType: isActive ? 'disableButton' : 'enableButton',
  });
  const dispatch = useAppDispatch();
  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleDeleteEntity = async () => {
    setLoading(true);
    await mutation();
    refetch();
    setLoading(false);
    handleClose();
  };
  return (
    <ConfirmationModal
      open
      onClose={handleClose}
      onSubmit={handleDeleteEntity}
      header={isActive ? 'Disable Confirmation' : 'Enable Confirmation'}
      confirmActionLabel={isActive ? 'Disable' : 'Enable'}
      modalType={isActive ? 'danger' : 'primary'}
      disabled={loading}
      trackContext={textDictionary.trackContext}
      trackConfirmAction={textDictionary.trackToggleConfirmAction}
      trackCancelAction={textDictionary.trackToggleCancelAction}
    >
      {textDictionary.description}
    </ConfirmationModal>
  );
};

export default PermissionToggleModal;
